import React from 'react';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Styled from '../styled';
import { useRuleChart } from './hooks';
import {
  Button, Modal, PageTitle,
} from '../../../../../../../components';
import { GRAPH_TITLE, MODAL } from './enums';
import { imageList } from '../../../../../../../utils';
import type { useSummaryReport } from '../../../../Components/SummaryReport/hooks';

type RuleCheckProps = {
  summaryHook: ReturnType<typeof useSummaryReport>
}

export const RuleChecksGraph = ({ summaryHook }: RuleCheckProps) => {
  const hook = useRuleChart(summaryHook);

  return (
    <Styled.Wrapper>
      <Styled.TitleWrapperStyled>
        <Styled.TitleStyled>{GRAPH_TITLE}</Styled.TitleStyled>
        <Button
          theme="quaternary"
          onClick={hook.hookSetIsModalOpen}
        >
          <FontAwesomeIcon icon={faQuestionCircle} />
        </Button>
      </Styled.TitleWrapperStyled>
      <Styled.MapWrapperStyled>
        {hook.hookGraphLoading ? (
          <Styled.FigureStyled>
            <img
              src={imageList.ruleCheckPlaceholder.src}
              alt={imageList.ruleCheckPlaceholder.alt}
            />
          </Styled.FigureStyled>
        ) : (<Styled.MapStyled id="ruleCheck" />)}
      </Styled.MapWrapperStyled>
      <Modal
        isOpen={hook.hookIsModalOpen}
        closeModalFunction={() => {
          if (hook.hookIsModalOpen) {
            hook.hookSetIsModalOpen();
          }
        }}
      >
        <Styled.ModalWrapperStyled>
          <PageTitle>{MODAL.TITLE}</PageTitle>
          <Styled.ModalTextStyled>{MODAL.DESCRIPTION}</Styled.ModalTextStyled>
          <Styled.FigureStyled>
            <img
              src={imageList.ruleCheckSample.src}
              alt={imageList.ruleCheckSample.alt}
            />
          </Styled.FigureStyled>
          {MODAL.CHECK.map((item, index) => (
            <Styled.ModalCheckWrapperStyled key={item.TITLE}>
              <Styled.CheckColorStyled index={index} />
              <Styled.ModalCheckWrapperStyled column>
                <Styled.ModalCheckTypeStyled>{item.TITLE}</Styled.ModalCheckTypeStyled>
                <Styled.ModalTextStyled>{item.DESCRIPTION}</Styled.ModalTextStyled>
              </Styled.ModalCheckWrapperStyled>
            </Styled.ModalCheckWrapperStyled>
          ))}
        </Styled.ModalWrapperStyled>
      </Modal>
    </Styled.Wrapper>
  );
};
